import { Config } from '../../config'
export const technimarkConfig: Config = {
  partner: 'technimark',
  catalog: 'partner',
  displayName: 'Technimark',
  accentColor: '#4a8eff',
  host: 'seating.technimark.com'
}